module.exports = __webpack_public_path__ + "static/media/anonymous-transparent.f0f729d5.svg";